import { render, staticRenderFns } from "./ArticleCard.vue?vue&type=template&id=2bfcc82c&scoped=true&"
import script from "./ArticleCard.vue?vue&type=script&lang=js&"
export * from "./ArticleCard.vue?vue&type=script&lang=js&"
import style0 from "./ArticleCard.vue?vue&type=style&index=0&id=2bfcc82c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfcc82c",
  null
  
)

export default component.exports